﻿import React from 'react';
import './ProgressBar.css';

export const ProgressBar = () => {
  return <div className="progress" data-progress aria-hidden="true" />;
};